
/**
 *  02/04/2019 v 1.0 - JuanMa
 *  v1.1 02/09/2019 Añadidas funciones de Foreign segundo nivel
 *  v1.2 10/10/2019 Añadidas funciones esForeignJPA y getValorDeForeignJPA
 *  v1.3 22/10/2019 Modificada función getValorDeForeign2Nivel para proteger el caso que datos sea null
 *  v1.4 23/03/2020 Añadida la funcion getRaizForeign
 *  v1.5 03/08/2021 Añadida la funcion getCampoForeignCodigo
 * */

import {aparicionesSubcadena} from "./StringUtils";
import {getValorPropiedad} from "./ObjectUtils";


export const esForeignPorPunto= (campoNombre) => {
    let posPunto= campoNombre.lastIndexOf(".");
    return posPunto >= 0;
}

export const esForeign= (campoNombre) => {
    if (campoNombre) {
        return campoNombre.includes("com.ej2sistemas");
    }
    return false;
}

export const getForeign= (nombreClase) => {
    let posPunto= nombreClase.lastIndexOf(".");
    if (posPunto >= 0)
        return nombreClase.substr(0, posPunto);
    else
        return null;
}

export const getCampoDeForeign= (nombreClase) => {
    let posPunto= nombreClase.lastIndexOf(".");
    if (posPunto >= 0)
        return nombreClase.substr(posPunto+1);
    else
        return null;
}

//Desde el nombre campo "objeto.campo" obtenemos "objeto"
export const getRaizForeign= (nombreCampo) => {
    let posPunto= nombreCampo.lastIndexOf(".");
    if (posPunto >= 0)
        return nombreCampo.substr(0, posPunto);
    else
        return null;
}

//desde com.ej2sistemas.cPersonal.nombre, obtenemos personalCodigo
export const getCampoForeignCodigo= (nombreCampo) => {
    let raiz= getRaizForeign(nombreCampo);
    let posPunto= raiz.lastIndexOf(".");
    if (posPunto >= 0){
        //El +2 es para quitar la c de la Clase
        let campoForeignCodigo= raiz.slice(posPunto+2) + "Codigo";
        return campoForeignCodigo.charAt(0).toLowerCase() + campoForeignCodigo.slice(1);
    }
    return nombreCampo;
}

export const getValorDeForeign= (nombreClase, datos) => {
    console.log("getValorDeForeign");
    console.log("nombreClase: ", nombreClase);
    console.log("datos: ", datos);
    let clase= getForeign(nombreClase);
    console.log("clase: ", clase);
    let campo= getCampoDeForeign(nombreClase);
    console.log("campo: ", campo);
    let valor= "";
    if (datos.foreign[clase])
        valor= datos.foreign[clase][campo];
    return valor;
}



export const esForeign2Nivel= (campoNombre) => {
    let foreign= campoNombre.substr("com.ej2sistemas".length+1);
    return aparicionesSubcadena(foreign, ".") == 3;
}

export const getClaseDeForeign2Nivel= (nombreClase) => {
    return nombreClase.split(".")[1];
}

export const getCampoDeForeign2Nivel= (nombreClase) => {
    return nombreClase.split(".")[2];
}


export const getValorDeForeign2Nivel= (campoNombre, datos) => {
    let foreign= campoNombre.substr("com.ej2sistemas".length+1).split(".");
    let proyecto= foreign[0];
    let claseFK= foreign[1];
    let claseFK2N= foreign[2];
    let campoFK2N= foreign[3];
    let clase= "com.ej2sistemas." + proyecto + "." + claseFK;
    let clase2Nivel= "com.ej2sistemas." +  proyecto + "." + claseFK2N;
    let valor= "";

    if (datos && datos.foreign && datos.foreign[clase] &&
        datos.foreign[clase].foreign[clase2Nivel][campoFK2N])
        valor= datos.foreign[clase].foreign[clase2Nivel][campoFK2N];
    else
        console.log(datos);
    return valor;
}


export const esForeignJPA= (campoNombre) => {
    if (campoNombre)
        return campoNombre.includes(".");
    return false;
}

export const getValorDeForeignJPA= (nombreClase, datos) => {
    return getValorPropiedad(datos, nombreClase);
}

